/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioCacheRefreshStatus = {
    COMPLETED: 'COMPLETED'
} as const;
export type PortfolioCacheRefreshStatus = typeof PortfolioCacheRefreshStatus[keyof typeof PortfolioCacheRefreshStatus];


export function instanceOfPortfolioCacheRefreshStatus(value: any): boolean {
    for (const key in PortfolioCacheRefreshStatus) {
        if (Object.prototype.hasOwnProperty.call(PortfolioCacheRefreshStatus, key)) {
            if (PortfolioCacheRefreshStatus[key as keyof typeof PortfolioCacheRefreshStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioCacheRefreshStatusFromJSON(json: any): PortfolioCacheRefreshStatus {
    return PortfolioCacheRefreshStatusFromJSONTyped(json, false);
}

export function PortfolioCacheRefreshStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCacheRefreshStatus {
    return json as PortfolioCacheRefreshStatus;
}

export function PortfolioCacheRefreshStatusToJSON(value?: PortfolioCacheRefreshStatus | null): any {
    return value as any;
}

export function PortfolioCacheRefreshStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioCacheRefreshStatus {
    return value as PortfolioCacheRefreshStatus;
}

